import React from 'react'

import { HeroCentered } from './HeroCentered'
import { Features2x2Grid } from './Features2x2Grid'
import { FeaturesWithImagesAlternatingSide } from './FeaturesWithImagesAlternatingSide'
import { FeaturesCards } from './FeaturesCards'
import { VisualsSideBySide } from './VisualsSideBySide'
import { TabsWithCode } from './TabsWithCode'
import { TestimonialCentered } from './TestimonialCentered'
import { ImageOverlappingBackground } from './ImageOverlappingBackground'
import { GraphiQlOverlappingBackground } from './GraphiQlOverlappingBackground'
import { RelatedFeature } from './RelatedFeature'
import { MarketingPageBlocksItem } from 'types/generated/contentful'
import { HeadlineWithEmbed } from './HeadlineWithEmbed'

type BlockRendererProps = {
  block: MarketingPageBlocksItem | MarketingPageBlocksItem[]
}

const BlockRenderer = ({ block }: BlockRendererProps) => {
  if (Array.isArray(block)) {
    return (
      <>
        {block.map((b) => (
          <BlockRenderer key={`block-${b.sys.id}`} block={b} />
        ))}
      </>
    )
  }

  const contentTypename = block.__typename!
  const Component = ContentTypeMap[contentTypename]

  if (!Component) {
    console.warn(`${contentTypename} can not be handled`)
    return null
  }

  const { id } = block.sys

  const componentProps = {
    ...block,
  }

  return (
    <Component key={`${contentTypename}-${id}`} {...(componentProps as any)} />
  )
}

const ContentTypeMap = {
  ComponentHeroCentered: HeroCentered,
  ComponentFeatures2X2Grid: Features2x2Grid,
  ComponentFeaturesWithImagesAlternatingSide: FeaturesWithImagesAlternatingSide,
  ComponentFeaturesCards: FeaturesCards,
  ComponentVisualsSideBySide: VisualsSideBySide,
  ComponentTabsWithCode: TabsWithCode,
  ComponentTestimonialCentered: TestimonialCentered,
  ComponentImageOverlappingBackground: ImageOverlappingBackground,
  ComponentGraphiQlOverlappingBackground: GraphiQlOverlappingBackground,
  ComponentRelatedFeature: RelatedFeature,
  ComponentHeadlineWithEmbed: HeadlineWithEmbed,
}

export { BlockRenderer }
